import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H10L4 8v14h16V2zm-8 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
}), 'SdStorageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SdStorageSharp.js
// module id = 5951
// module chunks = 2